import React, { useEffect, useState, useRef } from "react";
import Layout from "../../components/layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductsAction } from "../../store/product/actions";
// import { getAllProductCategorysAction } from "../../store/productCategory/actions";
import {getCategories, reset} from "../../store/productCategory/productCategorySlice"
import {getProducts,productreset} from "../../store/product/productSlice"

import Category from "./Categories";
// import Bestsales from "./Bestsales";
import Products from "./Products";
import ProductsSkeleton from "./ProductsSkeleton";

import { Link } from "react-router-dom";
// import Search from "./Search";

interface productType {
  product: string;
  category: string;
  quantity: number;
}

const Shop = () => {
  const dispatch = useDispatch<any>();
  const { product } = useSelector((state: any) => state);
  const {categories, isLoading, isSuccess, isError, message} = useSelector((state:any) => state.productCategory)
  const [limit, setLimit] = useState(15);
  const [page, setPage] = useState(1);
  const [categoryName, setCategoryName] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const setCategory = useRef("");
  const handleScroll = () => {
    if((window.innerHeight + document.documentElement.scrollTop + 1) >= document.documentElement.scrollHeight){
      // setLoading(true);
      setPage((prev:any) => prev + 1);
      
    }
  }
  

  useEffect(() => {
    if(isError) {
      console.log(message)
    }
      dispatch(getCategories(`?`))
  
    return () => {
      dispatch(reset())
    }

  },[isError,message,dispatch])

  useEffect(() => {

      if (categoryName) {
        if(setCategory.current!==categoryName){
          
          setPage(1);
          dispatch(productreset());
        }
        if(categoryName === "all"){
          dispatch(getProducts(`?limit=9&page=${page}&status=Active`))
        setCategory.current = categoryName;
        }else{
          dispatch(getProducts(`?limit=9&page=${page}&category=${categoryName}&status=Active`))
          setCategory.current = categoryName;
        }
        

      } else {
        dispatch(getProducts(`?limit=9&page=${page}&status=Active`))

      }
      console.log(`setCategory : ${setCategory.current}`)
    // return () => {
    //   dispatch(productreset())
    // }
  }, [dispatch, limit, page, categoryName]);



  const totalPages = Math.ceil(product?.products?.length / limit);

  const handlePageChange = (newPage: number) => {
    if (newPage >= 0 && newPage < totalPages) {
      setPage(newPage);
    }
  };

  // useEffect(() => {
  //   if (searchKey === "") {
  //     getAllProductsAction(`?limit=${limit}&page=${page}`)(dispatch);
  //   }
  // }, [searchKey]);

  // const handleSearch = async (e: any) => {
  //   e.preventDefault();
  //   searchKey &&
  //     (await getAllProductsAction(
  //       `?limit=${limit}&page=${page}&sk=${searchKey}`
  //     )(dispatch));
  //   console.log(")))))>>>");
  // };



  useEffect(() => {
    
    window.addEventListener("scroll",handleScroll);
    if(page===1){
      dispatch(productreset())

    }
    return () => window.removeEventListener("scroll",handleScroll);
  },[])

  const allProducts = product?.products.reduce((acc:any, current:any) => acc.concat(current), []);








  return (
    <Layout>
      
        <Category
          categories={categories}
          setCategoryName={setCategoryName}
          categoryName={categoryName}
        />
                
<div className="amado_product_area section-padding-100">
            <div className="container-fluid">
            <div className="row">
                    <div className="col-12">
                        <div className="product-topbar d-xl-flex align-items-end justify-content-between">
                            {/* <!-- Total Products --> */}
                            <div className="total-products">
                                {/* <p>Showing 1-8 0f 25</p> */}
                                {/* <div className="view d-flex">
                                    <a href="#"><i className="fa fa-th-large" aria-hidden="true"></i></a>
                                    <a href="#"><i className="fa fa-bars" aria-hidden="true"></i></a>
                                </div> */}
                            </div>
                            {/* <!-- Sorting --> */}
                            <div className="product-sorting d-flex">
                                {/* <div className="sort-by-date d-flex align-items-center mr-15">
                                    <p>Sort by</p>
                                    <form action="#" method="get">
                                        <select name="select" id="sortBydate">
                                            <option value="value">Date</option>
                                            <option value="value">Newest</option>
                                            <option value="value">Popular</option>
                                        </select>
                                    </form>
                                </div> */}
                                {/* <div className="view-product d-flex align-items-center">
                                    <p>View</p>
                                    <form action="#" method="get">
                                        <select name="select" id="viewProduct">
                                            <option value="value">all</option>
                                            {/* <option value="value">24</option>
                                            <option value="value">48</option>
                                            <option value="value">96</option> 
                                        </select>
                                    </form>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <Products products={allProducts} />
                {product?.isLoading && <ProductsSkeleton cards={6} />}

          </div>
          </div>       
        
         </Layout>
  );
};

export default Shop;
